import * as Highnote from './_highnote'
import Animated from 'react-native-reanimated'
import { BottomSheetView } from '@gorhom/bottom-sheet'
import { CardActivityFeedProps } from './feed'

export const Error = ({
  children,
  cardActivityFeedBottomSheetHeightStore,
}: CardActivityFeedProps) => (
  <>
    {children}
    <Highnote.CardActivityFeedBottomSheet
      cardActivityFeedBottomSheetHeightStore={cardActivityFeedBottomSheetHeightStore}
    >
      <Animated.View style={cardActivityFeedBottomSheetHeightStore.animatedStyles}>
        <BottomSheetView style={{ flex: 1, justifyContent: 'center' }}>
          <></>
        </BottomSheetView>
      </Animated.View>
    </Highnote.CardActivityFeedBottomSheet>
  </>
)
